export default {
  Click: {
    mounted() {
      this.handleEvent('click', ({ id }) => document.getElementById(id).click());
    },
  },
};
